// JavaScript Document
// eslint-disable-next-line no-unused-vars
export default class Location {
  facid = '0000';
  floor = '000';
  room = '0';

  constructor(obj) {
    if (typeof obj === 'undefined' || obj == null) return;

    if (typeof obj.facid !== 'undefined') this.facid = obj.facid;
    if (typeof obj.floor !== 'undefined') this.floor = obj.floor;
    if (typeof obj.room !== 'undefined') this.room = obj.room;
  }

  static location(facid, floor, room) {
    if (typeof facid === 'undefined' || facid == '') facid = '0000';
    if (typeof floor === 'undefined' || floor == '') floor = '000';
    if (typeof room === 'undefined' || room == '') room = '0';
    const location = new Location();
    location.facid = facid;
    location.floor = floor;
    location.room = room;
    return location;
  }
}

export { Location };
